import styled from 'styled-components';

import { AnimatedNumber } from '#src/atoms/animations/AnimatedNumber/index.tsx';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { GemIcon } from '#src/atoms/icons/GemIcon.tsx';
import { Plus } from '#src/atoms/icons/Plus.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { useOpenDialog } from '#src/hooks/navigation/useOpenDialog.ts';
import { useEvents } from '#src/lib/events/useEvents.ts';
import { OpenBuyGemsDialog_Context } from '#src/protos/events/so5/shared/events.ts';
import { thinMaterial } from '#src/style/utils.tsx';

const Root = styled(ButtonBase)`
  ${thinMaterial}
  border-radius: var(--unit);
  padding: var(--half-unit) var(--intermediate-unit);
  background: var(--c-nd-50);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--half-unit);

  &:hover,
  &:focus {
    background: var(--c-nd-200);
  }
  & svg {
    width: var(--unit);
    height: var(--unit);
  }

  &.vertical {
    padding: var(--half-unit);
    gap: 0;
    background: transparent;
  }
`;

const PlusIcon = styled(Horizontal).attrs({ gap: 0, center: true })`
  background-color: var(--c-blue-400);
  border-radius: 50%;
  width: var(--intermediate-unit);
  height: var(--intermediate-unit);
  outline: 1px solid var(--c-nd-50-opaque);
  margin-left: -7px;
`;

type Props = { balance: number; variant?: 'vertical' | 'horizontal' };
export const GemsBalance = ({ balance, variant }: Props) => {
  const track = useEvents();
  const openDialog = useOpenDialog();

  if (variant === 'vertical') {
    return (
      <Root
        onClick={() => {
          track('Open Buy Gems Dialog', {
            context: OpenBuyGemsDialog_Context.GEMS_BALANCE,
          });
          openDialog(DialogKey.buyGems, 'true');
        }}
        className="vertical"
      >
        <Vertical center gap={0.5}>
          <Horizontal gap={0.5}>
            <GemIcon size={1.5} />
            {balance <= 0 && (
              <PlusIcon>
                <Plus fill="white" />
              </PlusIcon>
            )}
          </Horizontal>
          <LabelM bold>
            <AnimatedNumber value={balance} disableAnimationOnFirstRender />
          </LabelM>
        </Vertical>
      </Root>
    );
  }

  return (
    <Root
      onClick={() => {
        track('Open Buy Gems Dialog', {
          context: OpenBuyGemsDialog_Context.GEMS_BALANCE,
        });
        openDialog(DialogKey.buyGems, 'true');
      }}
    >
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={balance} disableAnimationOnFirstRender />
        </LabelM>
        <GemIcon size={1.5} />
        {balance <= 0 && (
          <PlusIcon>
            <Plus fill="white" />
          </PlusIcon>
        )}
      </Horizontal>
    </Root>
  );
};
